import { createSelector } from 'reselect';

import { IIntState } from '../../../../modules/internationalization/intReducer';
import { selectInt } from '../../../../modules/internationalization/intSelectors';
import { dcRulesApi } from './store';

/*
* -------------------------------------------
*               Translation
* -------------------------------------------
*/

export const dcRulesTranslationSelector = () =>
    createSelector(
        selectInt,
        (state: IIntState) => state.translation.pageSubscriberId.tabs.dcRules,
    );

/*
* -------------------------------------------
*               Api
* -------------------------------------------
*/

const dcRulesApiSelector = (subscriberId: string) => dcRulesApi.endpoints.getDcRules.select({ subscriberId });

// active rules

export const dcRuleActiveSelector = (subscriberId: string) => createSelector(
    dcRulesApiSelector(subscriberId),
    dcRules => dcRules.data?.activeRule?.rules,
);

export const dcRuleNotificationSelector = (subscriberId: string) => createSelector(
    dcRulesApiSelector(subscriberId),
    dcRules => dcRules.data?.activeRule?.notification,
);

export const dcRuleScheduleListSelector = (subscriberId: string) => createSelector(
    dcRulesApiSelector(subscriberId),
    dcRules => dcRules.data?.activeRule?.scheduleList,
);

// all rules

export const dcRuleListSelector = (subscriberId: string) => createSelector(
    dcRulesApiSelector(subscriberId),
    dcRules => dcRules.data?.list ?? [],
);
